/** Warn once when an exam has 5 minutes (or less) left. */
export const EXAM_TIME_WARNING_SECONDS = 5 * 60;

export const FIVE_MINUTE_WARNING_MESSAGE =
  "5 minutes remaining. Review your answers and prepare to submit.";

export function getRemainingSeconds(data) {
  if (data == null) return 0;
  if (typeof data.total === "number" && !Number.isNaN(data.total)) {
    return Math.max(0, Math.ceil(data.total / 1000));
  }
  return (
    Number(data.hours || 0) * 3600 +
    Number(data.minutes || 0) * 60 +
    Number(data.seconds || 0)
  );
}

/**
 * Returns true the first time remaining time drops to 5 minutes or below.
 * Skips exams whose total duration is already 5 minutes or shorter.
 */
export function shouldWarnFiveMinutesLeft({
  data,
  timeDurationMinutes,
  alreadyWarned,
}) {
  if (alreadyWarned) return false;
  const durationMinutes = Number(timeDurationMinutes) || 0;
  if (durationMinutes <= 5) return false;

  const remaining = getRemainingSeconds(data);
  return remaining > 0 && remaining <= EXAM_TIME_WARNING_SECONDS;
}
